import { enableProdMode, provideZoneChangeDetection } from '@angular/core';

import * as Sentry from '@sentry/angular';
import { ignoreHttpErrorsIntegration } from './app/core/ignore-http-errors.integration';

import { environment } from './environments/environment';

import 'hammerjs';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { versionInfo } from './app/version-info';

if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: environment.sentry.dns,
  environment: environment.environment,
  normalizeDepth: 5,
  release: versionInfo.buildNumber,
  integrations: [ignoreHttpErrorsIntegration()],
  ignoreErrors: [
    'Illegal invocation',
    /Cannot read property 'loaded' of undefined/,
    /Can't find variable: fbq/,
    'fbq is not defined',
    '@safari-extension',
    'InvalidAccessError: The object does not support the operation or argument.',
    'Block-scoped declarations (let, const, function, class) not yet supported outside strict mode',
    /Failed to execute 'sendBeacon' on 'Navigator'/,
    'Non-Error promise rejection captured',
    // CookieYes banner error when the registered URL differs from the host
    /Looks like your website URL has changed/,
    /Failed to fetch dynamically imported module/, // Chromium chunk error
    /error loading dynamically imported module/, // Firefox chunk error
    /Importing a module script failed/, // WebKit chunk error
  ],
  // Third-party scripts we do not control and cannot act on
  denyUrls: [/cdn-cookieyes\.com/],
  beforeSend(event) {
    if (
      !environment.sentry.enabled ||
      window.location.href.includes('localhost')
    ) {
      // Console error message when developing
      console.error(
        'Sentry debug message',
        event.message,
        event.extra,
        event.contexts
      );
      return null;
    }
    return event;
  },
});

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [provideZoneChangeDetection(), ...appConfig.providers],
}).catch((err) => console.error(err));
